import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PlatformAccessService } from '../../core/src/platform-access.service';

@Injectable()
export class PamInterceptor implements HttpInterceptor {
  private readonly platformAccessService = inject(PlatformAccessService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.platformAccessService.checkPlatformAccess();
        }
        return throwError(() => error);
      }),
    );
  }
}
